import { render, staticRenderFns } from "./FormResponses.vue?vue&type=template&id=50119872&"
import script from "./FormResponses.vue?vue&type=script&lang=js&"
export * from "./FormResponses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports